import {
  NormalTextInputField,
  RepeatableMultipleInputStackFilds,
} from "@/components";
import React, { useMemo } from "react";

const InvestorsCornerFourthTabFormFields = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleImageChange,
  addMultiValueRepeaterChange,
  removeMultiValueRepeaterChange,
  updateMultiValueRepeaterChange,
  adminRole,
  permissionsList,
  colorGrade,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Table Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Table Heading"
            fieldId="downloads-table-heading"
            fieldName="downloads-table-heading"
            placeholderText="Table Heading"
            inputValue={formData?.["downloads-table-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Button Label */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Download Button Label"
            fieldId="downloads-button-label"
            fieldName="downloads-button-label"
            placeholderText="Button Label"
            inputValue={formData?.["downloads-button-label"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Link Button Label */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Link Button Label"
            fieldId="downloads-link-button-label"
            fieldName="downloads-link-button-label"
            placeholderText="Link Button Label"
            inputValue={formData?.["downloads-link-button-label"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Multi Downloads */}
          <RepeatableMultipleInputStackFilds
            stateDetails={formData}
            isFetching={isFetching}
            allFilesResponse={allFilesResponse}
            labelText="Download Content"
            fieldId="downloads-content"
            fieldKey="downloads-content"
            searchValue={searchValue}
            selectedFileType={selectedFileType}
            adminRole={adminRole}
            permissionsList={permissionsList}
            addMultiValueRepeaterChange={addMultiValueRepeaterChange}
            removeMultiValueRepeaterChange={removeMultiValueRepeaterChange}
            updateMultiValueRepeaterChange={updateMultiValueRepeaterChange}
            translateField={true}
            extraContainerClasses="mt-5"
            filedStructure={["TEXT", "IMAGE", "TEXT"]}
            dataStructure={{ label: "", value: "", fullUrl: "" }}
            placeholderTexts={["Label Text", "", "URL"]}
            hideStatus={[true, isHideInOtherLanguages, isHideInOtherLanguages]}
            extraInfos={[
              "",
              "",
              "Provide full URL if you don't want to use file to upload.",
            ]}
            colorGrade={colorGrade}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default InvestorsCornerFourthTabFormFields;
